import * as React from 'react'

import { Box, List, Text } from '@factorialco/deprecated-design-system'
import { OwnersSectionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { OwnerItem } from './OwnerItem'

interface OwnersListProps {
  owners: OwnersSectionFragment[]
}

export const OwnersList = ({ owners }: OwnersListProps) => {
  if (!owners) {
    return (
      <Box aria-label="List of owners" gap="s32" alignItems="center">
        <Text.Normal size="200">
          {i18n.t('performance_process.reviews.basic_information_section.owners.no_owners')}
        </Text.Normal>
      </Box>
    )
  }

  return (
    <Box aria-label="List of owners">
      <List>
        {owners.map((owner) => (
          <OwnerItem key={owner.id} owner={owner} hasOnlyOneOwner={owners.length === 1} />
        ))}
      </List>
    </Box>
  )
}
